import { COLORS } from "../../../styles/variables";

export const CardInfo = {
  width: '360px',
  maxHeight: '808px',
  height: '100%',
  overflowY: 'auto',
  padding: 5,
}

export const BoxImg = {
  aspectRatio: '1 / 1',
  width: '100%',
  objectFit: 'cover',
  borderRadius: '12px',
}

export const LikeJoinStack = {
  width: '100%', 
  display: 'grid', 
  gridAutoFlow: 'column',
  gridAutoColumns: '1fr',
}

export const CardImg = {
  height: '60px',
  width: '60px',
  objectFit: 'cover',
  borderRadius: '50%',
}

export const TypTags = {
  fontSize: '16px', 
  fontWeight: 400, 
  color: COLORS.BLACK,

  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 1,
}

export const linkStyle = {
  minWidth: 0, 
  flex: 1, 
  overflow: "hidden", 
  textOverflow: "ellipsis", 
  color: COLORS.BLACK,
  fontSize: 14,
  fontWeight: 300,
  textDecoration: "none",
  "&:hover": { color: COLORS.BLACK, textDecoration: "underline" },
  "&:visited": { color: COLORS.BLACK },
}